import React, {Component} from 'react';
import { Popover } from 'react-bootstrap'
import BootstrapTable from 'react-bootstrap-table-next';

import MODERNIZATION_FACTORS from '../resources/modernization-factors';
import { PATH1, PATH2, PATH3, PATH4, PATH5 } from '../resources/modernization-paths';

class ModernizationFactorsPopover extends Component {

    countFactors(data) {
        let factorCounts = {};
        let paths = {};

        for (let assetName in data) {
            const factors = data[assetName].modernizationFactors;
            //const assetType = data[assetName].assetType;

            if (factors) {
                for (let factor of factors) {
                    //let query = v.query;
                    if (factorCounts[factor]) {
                        // TODO: this isn't good enough. There could be multiple matches in one
                        factorCounts[factor]++;
                    } else {
                        factorCounts[factor] = 1;
                    }

                    switch(MODERNIZATION_FACTORS[factor].path) {
                        case 1:
                            paths[factor] = PATH1;
                            break;
                        case 2:
                            paths[factor] = PATH2;
                            break;
                        case 3:
                            paths[factor] = PATH3;
                            break;
                        case 4:
                            paths[factor] = PATH4;
                            break;
                        case 5:
                            paths[factor] = PATH5;
                            break;
                    }
                }
            }
        }

        // Convert object to array
        return Object.keys(factorCounts).map((k) => {
            return { "factor": k, "path": paths[k], "count": factorCounts[k] }
        });
    }

    getAssetsFromData(data) {
        const assets = JSON.parse(JSON.stringify(this.props.data));

        delete assets.archive;
        delete assets.engine;
        delete assets.project;
        delete assets.supportedPath;

        return assets
    }

    render() {
        const assets = this.getAssetsFromData(this.props.data);
        const factors = this.countFactors(assets);

        const headerStyle = {
            backgroundColor: '#f0f0f0'
        };

        const columns = [
            {
                dataField: 'factor',
                text: 'Modernization Factor',
                headerStyle: headerStyle,
            },
            {
                dataField: 'path',
                text: 'Modernization Path',
                headerStyle: headerStyle,
                sort: true
            },
            {
              dataField: 'count',
              text: 'Count',
              headerStyle: headerStyle,
              sort: true
            }
        ];

        return (
          <Popover id="popover-basic" title="Modernization Factors">
              <div>
                <h3>{this.props.data.project}</h3>
                <h4 style={{ color: '#777' }}>
                    Modernization Path: <span>{this.props.data.supportedPath}</span>
                </h4>
              </div>
              <BootstrapTable
                    keyField='job'
                    data={ factors }
                    columns={ columns }
                    defaultSorted={[
                        {
                            dataField: 'count',
                            order: 'desc'
                        }
                    ]}
              />
          </Popover>
        );
    }
};

export default ModernizationFactorsPopover;
